/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_TravelInputs */

const en_gc_home_travel = /** @type {(inputs: Gc_Home_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Travel`)
};

const zh_gc_home_travel = /** @type {(inputs: Gc_Home_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出行`)
};

/**
* | output |
* | --- |
* | "Travel" |
*
* @param {Gc_Home_TravelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_travel = /** @type {((inputs?: Gc_Home_TravelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_TravelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_travel(inputs)
	return zh_gc_home_travel(inputs)
});
export { gc_home_travel as "gc.home.travel" }